var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumanasLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 8,
    viewBox: "0 0 41 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8064 1.22392L11.8133 0.230788C11.5056 -0.0769295 11.0048 -0.0769295 10.6969 0.230788L9.70372 1.22392L10.5157 2.03591L11.2552 1.29643L11.9947 2.03591L12.8067 1.22392H12.8064Z",
    fill: "#D9381E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.1263 3.06763H12.3315C11.8962 3.06763 11.5419 3.42183 11.5419 3.85713V7.56516H12.6902V4.21588H14.1548V6.32292H15.303V4.21588H16.7676V7.56516H17.9159V3.85713C17.9159 3.42183 17.5616 3.06763 17.1263 3.06763Z",
    fill: "#D9381E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.6685 3.06763H25.0502C24.6149 3.06763 24.2607 3.42183 24.2607 3.85713V7.56516H25.409V4.21588H28.3095V7.56516H29.4578V3.85713C29.4578 3.42183 29.1036 3.06763 28.6683 3.06763H28.6685Z",
    fill: "#D9381E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.81994 6.4169H6.91936V3.06763H5.7711V7.56516H10.9682V3.06763H9.81994V6.4169Z",
    fill: "#D9381E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.40759 3.06807H1.14826V0.000488281H0V7.5656H1.14826V4.21632H4.04884V7.5656H5.1971V3.85757C5.1971 3.42227 4.84289 3.06807 4.40759 3.06807Z",
    fill: "#D9381E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M41 4.45084V3.85713C41 3.42183 40.6458 3.06763 40.2105 3.06763H36.5922C36.1569 3.06763 35.8026 3.42183 35.8026 3.85713V4.78281C35.8026 5.19411 36.1179 5.53493 36.5249 5.56929L39.8515 5.97326V6.41665H36.9509V6.06169H35.8026V7.56465H40.9997V5.65468C40.9997 5.24313 40.6844 4.90257 40.2772 4.86821L36.9509 4.46423V4.21563H39.8515V4.45059H40.9997L41 4.45084Z",
    fill: "#D9381E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M22.8974 3.06763H19.2791C18.8438 3.06763 18.4896 3.42183 18.4896 3.85713V4.45084H19.6379V4.21588H22.5384V4.66432H19.2791C18.8438 4.66432 18.4896 5.01853 18.4896 5.45383V7.56516H23.6867V3.85713C23.6867 3.42183 23.3325 3.06763 22.8972 3.06763H22.8974ZM22.5387 6.4169H19.6381V5.81258H22.5387V6.4169Z",
    fill: "#D9381E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M34.4396 3.06763H30.8213C30.386 3.06763 30.0318 3.42183 30.0318 3.85713V4.45084H31.1801V4.21588H34.0806V4.66432H30.8213C30.386 4.66432 30.0318 5.01853 30.0318 5.45383V7.56516H35.2289V3.85713C35.2289 3.42183 34.8747 3.06763 34.4394 3.06763H34.4396ZM34.0809 6.4169H31.1803V5.81258H34.0809V6.4169Z",
    fill: "#D9381E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanasLogo);
export default __webpack_public_path__ + "static/media/humanasLogo.d6d5d14942fa5a9aeca6b2c3eb6d3fd0.svg";
export { ForwardRef as ReactComponent };